var _rect, _rect2, _rect3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHeartPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 48,
    viewBox: "0 0 34 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 31.6,
    height: 46,
    rx: 5,
    fill: "white",
    stroke: "#413D45",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.79999,
    y: 4.79999,
    width: 24,
    height: 31.68,
    rx: 3,
    fill: "#C7DFF2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.67999,
    y: 39.36,
    width: 18.24,
    height: 2.88,
    rx: 1.44,
    fill: "#413D45"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5711 26.6966C17.1829 27.1011 16.5597 27.1011 16.1769 26.6966L10.2229 20.453C8.49515 18.6379 8.59903 15.6309 10.529 13.9579C12.213 12.4982 14.7226 12.7606 16.2644 14.3844L16.8713 15.0186L17.4837 14.3789C19.0255 12.7606 21.535 12.4982 23.219 13.9579C25.1545 15.6309 25.2529 18.6379 23.5252 20.453L17.5711 26.6966Z",
    fill: "#6DA6D4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeartPhone);
export default __webpack_public_path__ + "static/media/icon-heart-phone.8ca6bb03076085747bb862f56f7dce47.svg";
export { ForwardRef as ReactComponent };